import { faSearch, faSort, faSortDown, faSortUp, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { AppTable } from '../components/app-table';
import { isExists } from './entity-utils';
import { AppSimpleTable } from '../components/app-simple-table';
var AppTh = function (_a) {
    var fieldToSort = _a.fieldToSort, sortBy = _a.sortBy, direction = _a.direction, onClick = _a.onClick, message = _a.message;
    var onClickWrapper = onClick && sortBy ? function () { return onClick(sortBy); } : undefined;
    return (React.createElement("th", { className: 'position-relative', onClick: onClickWrapper },
        message,
        getSortIcon(fieldToSort, sortBy, direction)));
};
var AppThWithSearch = function (_a) {
    var fieldToSort = _a.fieldToSort, sortBy = _a.sortBy, direction = _a.direction, searchCallback = _a.searchCallback, onClick = _a.onClick, message = _a.message;
    var _b = React.useState(''), inputState = _b[0], setInputState = _b[1];
    var _c = React.useState(faSearch), searchIcon = _c[0], setSearchIcon = _c[1];
    React.useEffect(function () {
        if (inputState) {
            setSearchIcon(faTimes);
        }
        else {
            setSearchIcon(faSearch);
        }
        searchCallback(inputState);
    }, [inputState, searchCallback]);
    var onInputChange = function (event) {
        setInputState(event.currentTarget.value);
    };
    var onClickWrapper = onClick && sortBy ? function () {
        onClick(sortBy);
    } : undefined;
    var cleanInput = function () { return setInputState(''); };
    return (React.createElement("th", { className: 'position-relative' },
        React.createElement("input", { type: "text", value: inputState, onChange: onInputChange, placeholder: message, className: 'search-input_style' }),
        React.createElement(FontAwesomeIcon, { style: { height: '10px', width: '11px' }, icon: searchIcon, onClick: inputState ? cleanInput : undefined }),
        getSortIcon(fieldToSort, sortBy, direction, onClickWrapper)));
};
var AppThWrapper = function (_a) {
    var tableHeader = _a.tableHeader, onClick = _a.onClick, searchCallback = _a.searchCallback, fieldToSort = _a.fieldToSort, direction = _a.direction;
    var intl = useIntl();
    var rawString = tableHeader.rawString, translateId = tableHeader.translateId, translateValue = tableHeader.translateValue, sortBy = tableHeader.sortBy, searchable = tableHeader.searchable;
    var message = rawString;
    if (translateId) {
        message = translateValue ? React.createElement(FormattedMessage, { id: translateId, values: translateValue }) : React.createElement(FormattedMessage, { id: translateId });
        message = intl.formatMessage({ id: translateId }, translateValue);
    }
    if (searchable && searchCallback) {
        return (React.createElement(AppThWithSearch, { searchCallback: searchCallback, onClick: onClick, fieldToSort: fieldToSort, direction: direction, sortBy: sortBy, message: message }));
    }
    return (React.createElement(AppTh, { onClick: onClick, fieldToSort: fieldToSort, direction: direction, sortBy: sortBy, message: message }));
};
function buildTableHeaders(arr, onClick, fieldToSort, direction, searchCallback) {
    return arr.map(function (item, index) {
        if (item === null) {
            return (React.createElement("th", { key: index, "aria-label": ' ', className: 'position-relative' }));
        }
        return React.createElement(AppThWrapper, { key: index, tableHeader: item, direction: direction, searchCallback: searchCallback, onClick: onClick, fieldToSort: fieldToSort });
    });
}
function getSortIcon(fieldToSort, currentField, direction, onClick) {
    if (currentField === fieldToSort && currentField) {
        switch (direction) {
            case 'asc':
                return React.createElement(FontAwesomeIcon, { onClick: onClick || undefined, icon: faSortUp, className: 'ml-1' });
            case 'desc':
                return React.createElement(FontAwesomeIcon, { onClick: onClick || undefined, icon: faSortDown, className: 'ml-1' });
            case 'none':
                return React.createElement(FontAwesomeIcon, { onClick: onClick || undefined, icon: faSort, className: 'ml-1' });
            default:
                return null;
        }
    }
    else if (currentField) {
        return React.createElement(FontAwesomeIcon, { onClick: onClick || undefined, icon: faSort, className: 'ml-1' });
    }
    return null;
}
export function buildTable(headersArr, tableData, height, onClick, fieldToSort, direction, searchCallback) {
    var headers = buildTableHeaders(headersArr, onClick, fieldToSort, direction, searchCallback);
    return React.createElement(AppTable, { tableHeader: headers, tableData: tableData, scrollHeight: height, scrollOptions: { x: 'scroll', y: 'visible-hidden' } });
}
export function buildSimpleTable(headersArr, tableData, onClick, fieldToSort, direction) {
    var headers = buildTableHeaders(headersArr, onClick, fieldToSort, direction);
    return React.createElement(AppSimpleTable, { tableHeader: headers, tableData: tableData });
}
export function drawDashOrNot(data) {
    try {
        if (Array.isArray(data) && data.length < 1) {
            return React.createElement("span", null, "\u2014");
        }
        if (isExists(data, true)) {
            return data;
        }
        return React.createElement("span", null, "\u2014");
    }
    catch (e) {
        return React.createElement("span", null, "\u2014");
    }
}
//# sourceMappingURL=tables.js.map